var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "phone-wrapper" }, [
    _c(
      "label",
      {
        staticClass: "phone-number-label",
        class: { "tn-error": _vm.error },
        attrs: { for: "phoneNumber" }
      },
      [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "phone-number",
        class: { "tn-disabled": _vm.disabled, "tn-error": _vm.error }
      },
      [
        _c(
          "div",
          { staticClass: "phone-dropdown" },
          [
            _c(
              "VSelect",
              {
                staticClass: "mb-3 countryField",
                class: { "is-focused": _vm.focused },
                attrs: {
                  disabled: _vm.disabled || _vm.disablePrefix,
                  "hide-details": _vm.hideDetails,
                  items: _vm.countryList,
                  "menu-props": _vm.menuProps,
                  country: _vm.country,
                  flat: ""
                },
                on: { change: _vm.changedMobileCountry },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c("NsIcon", {
                          staticClass: "tn-icon",
                          attrs: {
                            "icon-name": "icon-chevron-down",
                            height: "20",
                            width: "20"
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.mobilePhoneNumber.country,
                  callback: function($$v) {
                    _vm.$set(_vm.mobilePhoneNumber, "country", $$v)
                  },
                  expression: "mobilePhoneNumber.country"
                }
              },
              [
                _vm._v(" "),
                _c("template", { slot: "selection" }, [
                  _c("span", { staticClass: "selected-code" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.mobilePhoneNumber.country) +
                        " (" +
                        _vm._s(_vm.phonePrefix) +
                        ")\n          "
                    )
                  ])
                ])
              ],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "phone-input" },
          [
            _c("VTextField", {
              staticClass: "phoneField",
              attrs: {
                id: "phoneNumber",
                name: "phoneNumber",
                type: "tel",
                disabled: _vm.disabled,
                "hide-details": _vm.hideDetails,
                rules: _vm.rules,
                "validate-on-blur": "",
                oninput: "value = value.replace(/[^0-9 .()+-]/g, '');"
              },
              on: {
                blur: _vm.receiveBlur,
                input: _vm.receiveInput,
                focus: function($event) {
                  _vm.focused = true
                }
              },
              model: {
                value: _vm.mobilePhoneNumber.number,
                callback: function($$v) {
                  _vm.$set(_vm.mobilePhoneNumber, "number", $$v)
                },
                expression: "mobilePhoneNumber.number"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }